<template>
  <div>
    <slot :basketHasBiozidDanger="basketHasBiozidDanger"></slot>
  </div>
</template>

<script>
export default {
  name: "biozid-checkout",

  computed: {
    basketHasBiozidDanger() {
      // Direkte Prüfung der Warenkorb-Artikel auf Biozid-Eigenschaft (ID 90)
      if (!this.$store.state.basket || !this.$store.state.basket.items || !Array.isArray(this.$store.state.basket.items)) {
        return false;
      }

      return this.$store.state.basket.items.some((item) => {
        if (!item.variation || !item.variation.data) {
          return false;
        }

        const variationProperties = item.variation.data.variationProperties;

        return (
          variationProperties &&
          Array.isArray(variationProperties) &&
          variationProperties.some((property) => property.properties && Array.isArray(property.properties) && property.properties.some((prop) => prop.id === 90))
        );
      });
    },
  },
};
</script>
